<template>
	<div class="text-center">
		<v-container>
			<div :class="['text-h6', 'pa-4']">
				{{ $t('titles.testimonialNumber') }}
			</div>
			<v-row>
				<v-col cols="12">
					<InputField
						:disabled="true"
						v-model="candidateFullName"
						:label="$t('fields.candidate')"
					></InputField>
				</v-col>
				<v-col cols="12">
					<InputField
						:readonly="inViewMode"
						v-model="testimonialNumber"
						:ajax="true"
						:errorBorder="!testimonialNumberValidation"
						:label="'* ' + $t('fields.testimonalNumber')"
					></InputField>
				</v-col>
			</v-row>
		</v-container>
		<v-spacer></v-spacer>
		<v-row>
			<v-col cols="12">
				<v-btn v-if="!inViewMode" class="ma-2" color="primary" variant="text" @click="saveClick">
					{{ $t('buttons.save') }}
				</v-btn>
				<v-btn class="ma-2" color="basicButton" variant="text" @click="cancelClick">
					{{ $t('buttons.cancel') }}
				</v-btn>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import InputField from '../../trinkets/InputField';

export default {
	name: 'CandidatePassedExam',
	components: { InputField },
	props: {
		inViewMode: Boolean,
		readonlyTestimonialNumber: [String, Number],
		preregistrationId: [String, Number],
		candidateFullName: [String, Number],
	},
	emits: ['close', 'reloadCandidatesRegistrations'],
	data() {
		return {
			testimonialNumber: null,
			testimonialNumberValidation: true,
		};
	},
	methods: {
		cancelClick() {
			this.testimonialNumber = null;
			this.$emit('close');
		},
		saveClick() {
			let success = true;

			if (this.testimonialNumber == null || this.testimonialNumber == '') {
				success = false;
				this.testimonialNumberValidation = false;
			} else {
				this.testimonialNumberValidation = true;
			}

			if (success) {
				let vm = this;
				this.$APICall(
					'put',
					'preregistrations/passed/' + this.preregistrationId,
					{
						testimonial_number: this.testimonialNumber,
					},
					(data, success) => {
						if (success) {
							vm.$notify(vm.$t('alerts.basicUpdate'));
							vm.$modalBus.$emit('reloadCandidatesRegistrations');
						} else {
							vm.$alert(vm.$t('alerts.basicError'));
						}
						this.$emit('close');
					}
				);
			}
		},
	},
	mounted() {
		if (this.inViewMode) {
			this.testimonialNumber = this.readonlyTestimonialNumber;
		}
	},
};
</script>
